import { render, staticRenderFns } from "./ExpandIcon.vue?vue&type=template&id=12e52631&scoped=true&"
import script from "./ExpandIcon.vue?vue&type=script&lang=js&"
export * from "./ExpandIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExpandIcon.vue?vue&type=style&index=0&id=12e52631&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e52631",
  null
  
)

export default component.exports